
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service-management/documents/notification",
      function () {
        return require("private-next-pages/service-management/documents/notification/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service-management/documents/notification"])
      });
    }
  